import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_BY_ID_WITH_DESCRIPTION } from '../../../../../graphql/equipment/equipment.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

export default function EquipmentDescription({ id }) {

    let equipment = {}

    const { loading, error, data } = useQuery(GET_EQUIPMENT_BY_ID_WITH_DESCRIPTION, {
        variables: { id }
    })

    if(data && data.equipment) {
        equipment = {...data.equipment}
    }
    
    return (<Card header={{ icon: null, title: "Description"}}>
        <CardDataPoint label="" value={equipment.description} />
    </Card>)
}